import { BackgroundColor } from "../../../background/constants/background-types";
import { RadioButtonSchemeDefinition } from "./radio-button-types";
import * as AllColors from "../../../../constants/colors";
import { toConstantCase } from "../../../../utils/string-format";
import { createRadioButtonMapDefinition } from "../../../../utils/scheme-helper";

function createSchemes() {
  let newSchemes: AllColors.RadioButtonSchemeConfiguration<RadioButtonSchemeDefinition> = {};

  AllColors.RADIO_BUTTON_SCHEMES.forEach((element) => {
    newSchemes[element.schemeName] = {
      labelColor: AllColors.COLOR_DARK,
      uncheckedColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_TINT_1`],
      uncheckedHoverColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      checkedColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      checkedHoverColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      errorColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_2`],
      disabledLabelColor: AllColors.COLOR_DARK_60,
      focusColor: AllColors[`COLOR_SYSTEM_HIGHLIGHT`],
      outlineColor: AllColors[`COLOR_SYSTEM_ERROR_DARK`],
      highlightedNecessityColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`]
    };
    if (element.scheme) {
      newSchemes[element.schemeName] = { ...newSchemes[element.schemeName], ...element.scheme };
    }
  });
  return newSchemes;
}

export const RADIO_BUTTON_SCHEME_CONFIG: AllColors.RadioButtonSchemeConfiguration<RadioButtonSchemeDefinition> = createSchemes();

export const RADIO_BUTTON_SCHEME_MAP: Map<BackgroundColor | "default", RadioButtonSchemeDefinition> = new Map(
  Object.entries(createRadioButtonMapDefinition()).map(([background, config]) => [
    background as BackgroundColor,
    RADIO_BUTTON_SCHEME_CONFIG[config as string]
  ])
);
